import React from 'react';
import { X } from 'lucide-react';

const ProblemSection = () => {
  const competitors = [
    {
      name: 'YNAB',
      problem: 'Teaches budgeting mechanics. Not why you overspend.',
    },
    {
      name: 'Credit Karma',
      problem: 'Shows your score. Not how to build wealth.',
    },
    {
      name: 'Mint',
      problem: 'Tracked your spending. Then shut down.',
    },
  ];

  return (
    <section
      data-testid="problem-section"
      className="bg-[#1B4332] section-padding relative overflow-hidden"
    >
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.3) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="container-custom relative z-10">
        {/* Main Headline */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2
            data-testid="problem-headline"
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#FAFAF7] leading-tight"
          >
            77% of Americans live paycheck to paycheck.
            <br className="hidden sm:block" />
            <span className="text-[#95B8A2]">Not because they don't earn enough.</span>
            <br className="hidden sm:block" />
            Because nobody ever taught them how
            <br className="hidden sm:block" />
            money actually works.
          </h2>
        </div>

        {/* Competitor Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-16">
          {competitors.map((competitor, index) => (
            <div
              key={competitor.name}
              data-testid={`competitor-card-${index}`}
              className="bg-[#FAFAF7] rounded-2xl p-6 shadow-lg animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#E74C3C]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <X className="w-4 h-4 text-[#E74C3C]" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-bold text-[#2D2D2D] mb-2">
                    {competitor.name}
                  </h3>
                  <p className="font-body text-sm text-[#2D2D2D]/70 leading-relaxed">
                    {competitor.problem}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Gold Divider */}
        <div className="flex items-center justify-center gap-4 mb-12">
          <div className="h-px w-16 sm:w-24 bg-[#D4AF37]/50" />
          <div className="w-2 h-2 bg-[#D4AF37] rounded-full" />
          <div className="h-px w-16 sm:w-24 bg-[#D4AF37]/50" />
        </div>

        {/* Solution Statement */}
        <div className="text-center">
          <h3
            data-testid="problem-solution"
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-[#D4AF37] italic"
          >
            Findell treats the disease.
            <br />
            Not the symptoms.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
